<template>
  <div id="cert_application_success_view">
    <div class="big-notice-label">
      恭喜您完成身份认证审核！
    </div>
    <div class="small-notice-label">
      {{timeValue}}s将自动跳转至<a href="javascript:void(0)" @click="gotoCertListPage">我的认证>></a>
    </div>
  </div>
</template>

<script>
import EventManager from "../../../js/event-common";

export default {
  name: "CertApplicationSuccessVue",
  props: {
    judge: {
      default: ()=> null
    }
  },
  data() {
    return {
      timeValue: 5,
      timeTimer: null,
      updateSuccess: false,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    myEventManager() {
      return this.$store.state.eventManager;
    }
  },
  mounted() {
    if (this.judge != null) {
      let status = this.judge.status;
      if (status == 5) {
        this.startTimer();
        this.updateJudgeStatus(6);
      }
    }
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    updateJudgeStatus(status) {
      let id = this.judge.id;
      let params = {
        status: status,
        auditStatus: 0,
        id,
      };
      let _this = this;
      this.httpManager.ajax.updateJudgeStatusData(params, function (data) {
        if (data.code == 0) {
          _this.updateSuccess = true;
          _this.$store.commit("needUpdateJudgeList", true);
          return;
        }
      }, function (data) {

      });
    },

    startTimer() {
      let _this = this;
      this.timeTimer = setInterval(function () {
        _this.timeValue -= 1;
        if (_this.timeValue < 0) {
          _this.clearTimer();
          _this.gotoCertListPage();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timeTimer != null) {
        clearInterval(this.timeTimer);
        this.timeTimer = null;
      }
    },
    gotoCertListPage() {
      if (!this.updateSuccess) {
        return;
      }
      this.$router.push({
        name: 'personalCertificatesVue'
      });
    }
  }
}
</script>

<style scoped>

  #cert_application_success_view {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;
  }

  #cert_application_success_view .big-notice-label {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
  }


  #cert_application_success_view .small-notice-label {
    font-size: 1rem;
    font-weight: bold;
    color: #333;
    margin-top: 30px;
  }

  #cert_application_success_view .small-notice-label a {
    color: #fc1a34;
  }


</style>



// WEBPACK FOOTER //
// src/components/certificates/application/CertApplicationSuccessVue.vue